import React, { ReactNode } from 'react';
import Select from 'react-select';

import {
  CmFormControl,
  CmFormLabelWithQuestionIcon,
  ReactSingleSelectInput,
} from '@/components/uiParts';
import { reactSelectStyle } from '@/components/uiParts/Form/Select/ReactSelect/style';

interface Props {
  fontWeight?: 'bold' | 'normal';
  width?: string;
  isClearable?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  closeMenuOnSelect?: boolean;
  label: string;
  name: string;
  singleSelectInput?: ReactSingleSelectInput;
  error?: ReactNode;
  question?: string;
}

export const CmLabelWithQuestionIconAndSingleReactSelect: React.FC<Props> = ({
  fontWeight = 'normal',
  width = '100%',
  isClearable = true,
  isRequired = false,
  isInvalid = false,
  closeMenuOnSelect = false,
  label,
  name,
  singleSelectInput,
  error,
  children,
  question,
}) => {
  return (
    <CmFormControl {...{ width, isInvalid }}>
      <CmFormLabelWithQuestionIcon {...{ fontWeight, isRequired, question }}>
        {label}
      </CmFormLabelWithQuestionIcon>
      <Select
        name={name}
        {...{ ...singleSelectInput, closeMenuOnSelect, isClearable }}
        styles={{
          ...reactSelectStyle,
        }}
      />
      {error}
      {children}
    </CmFormControl>
  );
};
